import { createApp } from 'vue';
import ElementPlus from 'element-plus';
import App from './App.vue';
import router from './router';
import store from './vuex';
import packageJson from '../package.json';

import 'element-plus/theme-chalk/index.css';

import './registerServiceWorker';

createApp(App)
  .use(ElementPlus)
  .use(router)
  .use(store)
  .mount('#app');

// eslint-disable-next-line no-console
console.log(`App version: ${packageJson.version}`);
